import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { graphqlService } from '../services/graphqlService';

const levels = [
  'Beginner',
  'Intermediate',
  'Advanced'
];

const PrescreeningLevel = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [selectedLevel, setSelectedLevel] = useState(null);

  const handleBack = () => {
    navigate('/welcome');
  };

  const handleNext = async () => {
    if (selectedLevel && user && user.email) {

      try {
        // Get existing prescreening data
        let existingData = {};
        try {
          const prescreening = await graphqlService.getPrescreening(user.email);
          if (prescreening) {
            existingData = prescreening;
          }
        } catch (error) {
          // No existing data, start fresh
        }

        // Update prescreening data
        await graphqlService.createOrUpdatePrescreening({
          userEmail: user.email,
          ...existingData,
          level: selectedLevel
        });
        
        navigate('/prescreening/category');
      } catch (error) {
        console.error('Error saving prescreening data:', error);
        alert('Failed to save data. Please try again.');
      }
    }
  };

  return (
    <div className="prescreening-container">
      <div className="prescreening-header">
        <button className="back-btn" onClick={handleBack}>
          <ArrowLeft size={20} />
          Back
        </button>
        <h1 className="prescreening-title">Choose Your Level</h1>
      </div>

      <div className="prescreening-progress">
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: '33%' }}></div>
        </div>
      </div>

      <div className="prescreening-content">
        <h2 className="prescreening-question">What is your experience level?</h2>
        
        <div className="goal-options">
          {levels.map((level) => (
            <button
              key={level}
              className={`goal-card ${selectedLevel === level ? 'selected' : ''}`}
              onClick={() => setSelectedLevel(level)}
            >
              {level}
            </button>
          ))}
        </div>

        <div className="prescreening-actions">
          <button 
            className="prescreening-next-btn"
            onClick={handleNext}
            disabled={!selectedLevel}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrescreeningLevel;

